/* ABC: страница /cart (телефон и ПК) — плавающая кнопка CHECKOUT.
   Висит внизу экрана той же ширины и высоты, что настоящая. Видна, только
   пока настоящая кнопка целиком ниже края экрана: как только хоть край
   настоящей заезжает на экран, плавающая исчезает. Раньше она пряталась,
   лишь когда настоящая доезжала до её места, — и в зазоре под плавающей
   виднелся верх настоящей: «CHECKOUT / CHECKOUT» одним чёрным блоком
   (владелец, Android, 28.09). */
(function () {
  if (!/^\/cart\/?$/.test(location.pathname)) return;
  var bar = document.createElement('div');
  bar.className = 'abc-sticky-checkout';
  bar.innerHTML = '<button type="button" class="abc-sticky-checkout__btn">Checkout</button>';
  document.body.appendChild(bar);
  var btn = bar.querySelector('button');
  btn.addEventListener('click', function () {
    var real = document.querySelector('.cart-page .cart__checkout-button');
    if (real) real.click();
  });

  var queued = false;
  /* раскрытие/закрытие DISCOUNT (и заметки) двигает настоящую кнопку без прокрутки
     и без новых узлов — раньше плавающая оставалась в старом состоянии и после
     закрытия DISCOUNT висела второй кнопкой под настоящей, пока не прокрутишь.
     Следим за размером блока итога (он плавно растёт/сжимается) и всей main */
  var ro = window.ResizeObserver ? new ResizeObserver(schedule) : null, box = null;
  function watch() {
    var b = document.querySelector('.cart-page .cart-summary__inner');
    if (!ro || b === box) return;
    if (box) ro.unobserve(box);
    box = b;
    if (b) ro.observe(b);
  }
  function update() {
    queued = false;
    watch();
    var real = document.querySelector('.cart-page .cart__checkout-button');
    var hasItems = document.querySelector('.cart-page .cart-items__table-row .cart-items__remove');
    if (!real || !hasItems) { bar.classList.remove('is-visible'); if (real) real.style.visibility = ''; return; }
    var r = real.getBoundingClientRect();
    /* место плавающей кнопки = там, где стоит настоящая по горизонтали */
    btn.style.left = r.left + 'px';
    btn.style.width = r.width + 'px';
    btn.style.height = r.height + 'px';
    /* нижний край того, что реально видно: на Android строка адреса
       и клавиатура уменьшают visualViewport, а не только innerHeight */
    var vv = window.visualViewport;
    var bottom = vv ? Math.min(innerHeight, vv.offsetTop + vv.height) : innerHeight;
    /* зазор 1px против мигания на границе (дробные пиксели, подрагивание
       строки адреса): показанная прячется, когда настоящая заехала на экран
       больше чем на 2px, спрятанная появляется, когда от настоящей осталось
       не больше 1px. Край в 1–2px — без надписи, так что ни двух надписей,
       ни момента совсем без кнопки */
    /* 30.09 (владелец: «телепортируется, не доходя до основной»): плавающая стоит на 20px выше низа экрана.
       Раньше она пропадала, как только настоящая показывалась у самого края, — скачок на 60px вниз.
       Теперь плавающая держится, пока настоящая не доедет ровно до её места, и тогда они меняются —
       без скачка. Пока настоящая едет под плавающей, её не видно (visibility), — двух CHECKOUT нет. */
    var slot = bottom - 20 - r.height;                    /* верх плавающей кнопки */
    var shown = bar.classList.contains('is-visible');
    var below = r.top > slot + (shown ? 0 : 1);
    if (below !== shown) bar.classList.toggle('is-visible', below);
    real.style.visibility = below ? 'hidden' : '';
  }
  function schedule() { if (!queued) { queued = true; setTimeout(update, 0); } }
  /* на ПК прокручивается не окно, а .page-wrapper (спрятанная полоса) —
     ловим прокрутку любого блока */
  document.addEventListener('scroll', schedule, { passive: true, capture: true });
  addEventListener('resize', schedule);
  if (window.visualViewport) {
    visualViewport.addEventListener('resize', schedule);
    visualViewport.addEventListener('scroll', schedule);
  }
  new MutationObserver(schedule).observe(document.querySelector('main') || document.body, { childList: true, subtree: true });
  if (ro) ro.observe(document.querySelector('main') || document.body);
  update();
})();

/* ABC: «SELECTED FOR YOU» подбирается под человека. Товар-образец —
   последний просмотренный (что ему интересно прямо сейчас), если такого
   нет — первый товар в корзине. Shopify по нему присылает похожие товары
   (учитывает, что смотрят и покупают вместе). */
(function () {
  if (!/^\/cart\/?$/.test(location.pathname)) return;
  var box = document.querySelector('product-recommendations[data-abc-cart-recs]');
  if (!box) return;
  function set(id) { if (id && !box.dataset.productId) box.dataset.productId = String(id); }
  var viewed = [];
  try { viewed = JSON.parse(localStorage.getItem('abc:recently-viewed')) || []; } catch (e) {}
  var first = viewed.map(function (v) { return typeof v === 'string' ? v : (v && v.handle); }).filter(Boolean)[0];
  var fromCart = function () {
    return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
      if (c.items && c.items[0]) set(c.items[0].product_id);
    });
  };
  if (first) {
    fetch('/products/' + encodeURIComponent(first) + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) { if (p && p.id) set(p.id); else return fromCart(); })
      .catch(fromCart);
  } else fromCart();
})();

/* ABC: быстрое добавление из «SELECTED FOR YOU» — под каждой карточкой
   ADD TO CART: окно размеров (как в избранном), выбрал — товар в корзине,
   корзина перерисовалась. Без захода в карточку товара. */
(function () {
  if (!/^\/cart\/?$/.test(location.pathname)) return;
  var cache = {};
  function load(h) {
    if (!cache[h]) cache[h] = fetch('/products/' + encodeURIComponent(h) + '?view=abcjson')
      .then(function (r) { return r.ok ? r.text() : null; })
      .then(function (t) { try { return t ? JSON.parse(t) : null; } catch (e) { return null; } });
    return cache[h];
  }
  function sections() {
    return [].map.call(document.querySelectorAll('cart-items-component'), function (el) { return el.dataset.sectionId; }).filter(Boolean).join(',');
  }
  function add(v) {
    /* не import(): Shopify сжимает его в require() — см. sections/abc-marquee.liquid (window.abcImport) */
    var imp = window.abcImport ? window.abcImport('@shopify/events') : Promise.reject(new Error('abcImport'));
    return imp.then(function (m) {
      var d = m.CartLinesUpdateEvent.createPromise();
      document.dispatchEvent(new m.CartLinesUpdateEvent({ action: 'update', context: 'cart', lines: [{ merchandiseId: String(v.id), quantity: 1 }], promise: d.promise }));
      var json = { 'Content-Type': 'application/json', Accept: 'application/json' };
      return fetch('/cart/add.js', { method: 'POST', headers: json, body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }] }) })
        .then(function () { return fetch('/cart/update.js', { method: 'POST', headers: json, body: JSON.stringify({ updates: {}, sections: sections(), sections_url: location.pathname }) }); })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          d.resolve({ cart: m.CartLinesUpdateEvent.createCartFromAjaxResponse(cart), detail: { sections: cart.sections, items: cart.items, itemCount: cart.item_count, source: 'abc-card-add', didError: false } });
        }, function (e) { d.reject(e); });
    });
  }
  function sheet(p) {
    var box = document.createElement('div');
    (p.variants || []).forEach(function (v) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'abc-sheet__opt' + (v.available ? '' : ' is-sold');
      b.innerHTML = '<span></span>' + (v.available ? '' : '<small>Notify me</small>');
      b.firstChild.textContent = v.title;
      b.addEventListener('click', function () {
        if (!v.available) {
          window.abcSheet.open({ title: 'Notify me', body: window.abcSheet.notifyForm({ title: p.title, handle: p.handle }, v.title) });
          return;
        }
        window.abcSheet.close(function () { add(v); });
      });
      box.appendChild(b);
    });
    window.abcSheet.open({ title: 'Select a size', body: box });
  }
  function decorate() {
    document.querySelectorAll('[data-abc-cart-recs] .product-card').forEach(function (card) {
      if (card.querySelector('.abc-card-add')) return;
      var a = card.querySelector('a[href*="/products/"]');
      if (!a) return;
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'abc-card-add';
      btn.textContent = 'Add to cart';
      btn.dataset.handle = (new URL(a.href, location.origin).pathname.match(/\/products\/([^/?#]+)/) || [])[1] || '';
      card.appendChild(btn);
    });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.abc-card-add');
    if (!b) return;
    e.preventDefault(); e.stopPropagation();
    load(b.dataset.handle).then(function (p) {
      if (!p || !window.abcSheet) return;
      var avail = (p.variants || []).filter(function (v) { return v.available; });
      if ((p.variants || []).length === 1 && avail.length) add(avail[0]); else sheet(p);
    });
  }, true);
  var box = document.querySelector('product-recommendations[data-abc-cart-recs]');
  if (box) { decorate(); new MutationObserver(decorate).observe(box, { childList: true, subtree: true }); }
})();

/* ABC: сумма за строку в корзине меняется сразу при «+/−» (сервер
   подтверждает через 0,8 с и перерисовывает то же самое). Мини-корзина и /cart. */
(function () {
  function fmt(cents, format) {
    /* ABC 29.09: формат магазина + знак валюты CA$/A$/HK$/S$/AED — assets/abc-money.js */
    if (window.abcMoney) return window.abcMoney.format(cents, format);
    var n = (cents / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return /\{\{\s*\w+\s*\}\}/.test(format || '') ? format.replace(/\{\{\s*\w+\s*\}\}/, n) : '$' + n;
  }
  document.addEventListener('quantity-selector:update', function (e) {
    var q = e.detail && e.detail.quantity;
    var row = e.target && e.target.closest && e.target.closest('.cart-items__table-row');
    var box = row && row.querySelector('.abc-line-price');
    if (!box || !(q > 0)) return;
    var now = box.querySelector('.abc-line-price__now'), was = box.querySelector('.abc-line-price__was');
    /* ABC 02.10: GIFT CARD (data-trim-zeros, snippets/cart-products.liquid) — без «.00/,00» на конце: €90, не €90,00
       (как money_without_trailing_zeros; €45,50 остаётся как есть) */
    var trim = box.hasAttribute('data-trim-zeros');
    if (now) now.textContent = trim
      ? fmt(Number(box.dataset.unit) * q, box.dataset.moneyFormat).replace(/[.,]00(?!\d)/, '')
      : fmt(Number(box.dataset.unit) * q, box.dataset.moneyFormat);
    if (was) was.textContent = fmt(Number(box.dataset.compareUnit) * q, box.dataset.moneyFormat);
  }, true);
})();
